import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export function useQueryParam() {
  const location = useLocation();
  const queryParams: any = queryString.parse(location.search);
  // TODO: handle + because at the moment it sets a + in the string to %20 with is white space https://www.w3schools.com/tags/ref_urlencode.ASP
  // // TODO: look over if this is a good enough solution or disallow boolean values that require this kind of parsing. How about the jira '][' issue?

  Object.keys(queryParams).forEach((queryParam) => {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(queryParams[queryParam])) {
      queryParams[queryParam] = parseInt(queryParams[queryParam], 10);
    }
    if (queryParams[queryParam] === 'true') {
      queryParams[queryParam] = true as boolean;
    }
    if (queryParams[queryParam] === 'false') {
      queryParams[queryParam] = false;
    }
  });

  return queryParams;
}
